<template>

<core-filter-config v-on:expand="onExpandClick" v-on:close="onCloseClick" v-on:save="onSaveClick" :state="is" :loginRequired="true" :selfOnly="true" :hideButton="window.width < 400">

	<app-config-template-plays-usernames />

	<app-config-template-sync-plays-incomplete />

	<app-config-template-insights-hindex-expansions />

</core-filter-config>

</template>

<script>

import Config from 'core/mixin/Config.js'

export default {

	mixins: [Config],

	data: function() {

		return {

			name: 'plays'
			
		}

	},

	methods: {

		onAfterSave: function() {

			this.$emit('refresh')

		}

	}

}

</script>